export default class RegisteredMacAddressBatchService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('registeredMacAddressBatches', params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('registeredMacAddressBatches/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('registeredMacAddressBatch/' + id, params)
	}

	createEntity(params){
		return this.apiService.callPost('registeredMacAddressBatch', params);
	}

	getUnregisteredMacAddressByIds(params){
		return this.apiService.callPost('getUnregisteredMacAddressByIds', params);
	}
}



// WEBPACK FOOTER //
// ./src/service/RegisteredMacAddressBatchService.js